import React, { useState } from "react";
import LoadingOverlay from "@components/LoadingOverlay/LoadingOverlay";
import Subheader from "@components/Subheader/Subheader";
import PageLayout from "@layouts/PageLayout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Accounts from "./grid/Accounts";
import { Licenses } from "./grid/Licenses";
import { PortOperatorLicenses } from "./grid/PortOperatorLicenses";
import RequestPortOperatorLicense from "./license-details/flow/request-port-operator-license/RequestPortOperatorLicense";

const TEST_ID_BASE = "licenses-page";

const LicensesContainer: React.FC = () => {
  const { i18n, t } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";
  const { user } = useAuthStore();
  const { pathname } = useLocation();
  const [canRequestPortOperatorLicense, setCanRequestPortOperatorLicense] = useState(false);

  const isPortOperatorContext =
    pathname.includes(paths.licenses.portOperatorIndex) ||
    user?.roles?.includes("managing-director-office");
  const isServiceDeskContext =
    pathname.includes(paths.licenses.accountIndex) || user?.roles?.includes("service-desk");
  const isVendorMasterContext =
    pathname.includes(paths.licenses.index) || user?.roles?.includes("vendor-master");

  const titleText = isPortOperatorContext
    ? t("licensing.port-operator-licenses-title", t("licensing.port-operator-license-title"))
    : isServiceDeskContext
      ? t("licensing.service-desk-license-title")
      : t("licensing.title");

  const [isLoading, setIsLoading] = useState(true);

  return (
    <PageLayout dir={dir}>
      <LoadingOverlay loading={isLoading} />
      <Subheader
        testId={`${TEST_ID_BASE}-subheader`}
        subtitle={titleText}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{titleText}</span>
            {isVendorMasterContext && canRequestPortOperatorLicense && (
              <RequestPortOperatorLicense />
            )}
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6">
        {isPortOperatorContext ? (
          <PortOperatorLicenses onIsLoading={setIsLoading} />
        ) : isServiceDeskContext ? (
          <Accounts onIsLoading={setIsLoading} />
        ) : isVendorMasterContext ? (
          <Licenses
            onIsLoading={setIsLoading}
            onCanRequestPortOperatorLicenseChange={setCanRequestPortOperatorLicense}
          />
        ) : null}
      </div>
    </PageLayout>
  );
};

export default LicensesContainer;
